export class TripDetailReportModel {
  startDateTime: string;
  endDateTime: string;
  distance: string;
  licensePlate: string;
  bookingId: string;
  contractTypeGroup: string;
  driverHashId: string;
  vehicleHashId: string = '';
  filterDriverName: string;
  filterOwnerName: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdetailreport/models/tripdetailreport.model.ts